import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NavigationBarMovilComponent } from 'projects/declarabid-private/src/app/shared/components/navigation-bar-movil/navigation-bar-movil.component';
import { NavigationBarComponent } from 'projects/declarabid-private/src/app/shared/components/navigation-bar/navigation-bar.component';

@Component({
  selector: 'app-rh',
  imports: [RouterOutlet, NavigationBarComponent, NavigationBarMovilComponent],
  templateUrl: './rh.component.html',
  styleUrl: './rh.component.scss',
})
export class RhComponent {}
